export default {
  title: 'ログイン画面',
  email: 'メールアドレス',
  emailPlaceholder: '入力してください',
  password: 'パスワード',
  passwordPlaceholder: '入力してください',
  rememberMe: 'ログイン情報を記憶する',
  forgotPassword: 'パスワードをお忘れの方',
  loginButton: 'ログイン',
  agreement: '私は#serviceAgreement#と#privacyAgreement#を読み、同意しました。',
  serviceAgreement: '利用规约',
  privacyAgreement: 'プライバシー契約',
  and: 'と',
  emailRequired: 'メールアドレスを入力してください',
  passwordRequired: 'パスワードを入力してください',
  emailInvalid: '入力されたメールアドレスの形式が正しくありません',
  passwordInvalid: 'パスワードは少なくとも8文字、文字と数字を含む必要があります',
  agreementRequired: '利用契約とプライバシー契約に同意してください',
  loading: 'ログイン中...',
  loginSuccess: 'ログイン成功',
  loginFailed: 'ログインに失敗しました',
};
